// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__15wlH","col":"styles_col__3nui7","fulfillmentStatus":"styles_fulfillmentStatus__3Q4p4","emailCol":"styles_emailCol__6_hL0"};